<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" focusable="false">
  <path *ngFor="let path of paths" [attr.d]="path.d" [attr.opacity]="path.opacity || null"></path>
</svg>
